module.exports = __webpack_public_path__ + "img/csv.06d0cacd.svg";